/**
 * 开发环境调试工具
 * 在生产环境中自动禁用所有调试输出
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * 开发环境日志输出
 */
export const debugLog = {
  /**
   * 普通日志
   */
  log: (message: string, ...data: any[]) => {
    if (isDevelopment) {
      console.log(`[DEBUG] ${message}`, ...data);
    }
  },

  /**
   * 信息日志
   */
  info: (message: string, ...data: any[]) => {
    if (isDevelopment) {
      console.info(`[INFO] ${message}`, ...data);
    }
  },

  /**
   * 警告日志
   */
  warn: (message: string, ...data: any[]) => {
    if (isDevelopment) {
      console.warn(`[WARN] ${message}`, ...data);
    }
  },

  /**
   * 错误日志
   */
  error: (message: string, error?: any, ...data: any[]) => {
    if (isDevelopment) {
      console.error(`[ERROR] ${message}`, error, ...data);
    }
  },

  /**
   * 性能调试
   */
  time: <T>(label: string, fn: () => T): T => {
    if (isDevelopment) {
      console.time(label);
      const result = fn();
      console.timeEnd(label);
      return result;
    }
    return fn();
  },
};

/**
 * API请求调试
 */
export const apiDebug = {
  request: (url: string, options?: any) => {
    debugLog.log(`API请求: ${options?.method || 'GET'} ${url}`, options);
  },

  response: (url: string, data: any, duration?: number) => {
    const message = duration
      ? `API响应: ${url} (${duration}ms)`
      : `API响应: ${url}`;
    debugLog.log(message, data);
  },

  error: (url: string, error: any, duration?: number) => {
    const message = duration
      ? `API错误: ${url} (${duration}ms)`
      : `API错误: ${url}`;
    debugLog.error(message, error);
  },
};

export default debugLog;
